<div class="mch-page">
  <div class="mch-header">
    <div>
      <h1>{{ pageTitleKey | translate }}</h1>
      <p *ngIf="pageSubtitle">{{ pageSubtitle }}</p>
      <p class="mch-org" *ngIf="organizationName">
        {{ 'COMPANY_NAME' | translate }}: {{ organizationName }}
        <span *ngIf="organizationId">· {{ organizationId }}</span>
      </p>
    </div>
    <div class="mch-header-actions">
      <button type="button" class="ghost-btn" (click)="goBack()">{{ 'BACK' | translate }}</button>
      <button
        type="button"
        class="primary-btn"
        *ngIf="viewMode && mId"
        (click)="goToEdit()"
      >
        {{ 'EDIT_MACHINE' | translate }}
      </button>
    </div>
  </div>

  <form [formGroup]="machineForm" (ngSubmit)="onSubmit()" class="mch-form">
    <section class="form-section">
      <h2>Identity</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">{{ 'MACHINE_ID' | translate }} <span class="req">*</span></span>
          <input class="form-control" formControlName="machineId" />
          <span class="field-error" *ngIf="machineForm.get('machineId')?.hasError('required') && machineForm.get('machineId')?.touched">{{ 'REQUIRED' | translate }}</span>
        </label>
        <label class="field">
          <span class="field-label">{{ 'MACHINE_NAME' | translate }} <span class="req">*</span></span>
          <input class="form-control" formControlName="machineName" />
          <span class="field-error" *ngIf="machineForm.get('machineName')?.hasError('required') && machineForm.get('machineName')?.touched">{{ 'REQUIRED' | translate }}</span>
        </label>
        <label class="field">
          <span class="field-label">{{ 'MACHINE_TYPE' | translate }} <span class="req">*</span></span>
          <input class="form-control" formControlName="machineType" />
          <span class="field-error" *ngIf="machineForm.get('machineType')?.hasError('required') && machineForm.get('machineType')?.touched">{{ 'REQUIRED' | translate }}</span>
        </label>
        <label class="field">
          <span class="field-label">{{ 'MACHINE_CATEGORY' | translate }}</span>
          <select class="form-control" formControlName="machineCategory">
            <option value="">—</option>
            <option *ngFor="let opt of dropdownOptions('machineCategory')" [value]="opt">{{ opt | translate }}</option>
          </select>
        </label>
        <label class="field">
          <span class="field-label">{{ 'SERIAL_NUMBER' | translate }}</span>
          <input class="form-control" formControlName="serialNumber" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'MANUFACTURER' | translate }}</span>
          <input class="form-control" formControlName="manufacturer" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'MODEL' | translate }}</span>
          <input class="form-control" formControlName="model" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'YEAR_OF_MANUFACTURE' | translate }}</span>
          <input class="form-control" type="number" formControlName="yearOfManufacture" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'SIGMA_ASSET_TAG' | translate }}</span>
          <input class="form-control" formControlName="sigmaAssetTag" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'QR_CODE_ID' | translate }}</span>
          <input class="form-control" formControlName="qrCodeId" />
        </label>
        <label class="field" *ngIf="branchList.length">
          <span class="field-label">{{ 'BRANCH_NAME' | translate }}</span>
          <select class="form-control" formControlName="branchId" (change)="onBranchSelected($any($event.target).value)">
            <option value="">—</option>
            <option *ngFor="let branch of branchList" [value]="branch.branch_id">{{ branch.branch_name }}</option>
          </select>
        </label>
      </div>
    </section>

    <section class="form-section">
      <h2>Project</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">{{ 'PROJECT_TYPE' | translate }}</span>
          <select class="form-control" formControlName="projectType">
            <option value="">—</option>
            <option *ngFor="let opt of dropdownOptions('projectType')" [value]="opt">{{ opt | translate }}</option>
          </select>
        </label>
        <label class="field">
          <span class="field-label">{{ 'PROJECT_ID' | translate }}</span>
          <input class="form-control" formControlName="projectId" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'PROJECT_NAME' | translate }}</span>
          <input class="form-control" formControlName="projectName" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'PROJECT_LOCATION' | translate }}</span>
          <input class="form-control" formControlName="projectLocation" />
        </label>
      </div>
    </section>

    <section class="form-section">
      <h2>Owner</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">Registered owner</span>
          <select class="form-control" formControlName="machineOwnerId" (change)="onMachineOwnerSelected($any($event.target).value)">
            <option value="">—</option>
            <option *ngFor="let owner of machineOwners" [value]="owner.id">
              {{ owner.owner_name }} ({{ owner.owner_code }})
            </option>
          </select>
          <a class="field-link" routerLink="/home/machine-owners">Onboard a machine owner</a>
        </label>
        <label class="field">
          <span class="field-label">{{ 'OWNER_TYPE' | translate }}</span>
          <select class="form-control" formControlName="ownerType">
            <option value="">—</option>
            <option *ngFor="let opt of dropdownOptions('ownerType')" [value]="opt">{{ opt | translate }}</option>
          </select>
        </label>
        <label class="field">
          <span class="field-label">{{ 'OWNER_NAME' | translate }}</span>
          <input class="form-control" formControlName="ownerName" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'OWNER_CONTACT' | translate }}</span>
          <input class="form-control" formControlName="ownerContact" />
        </label>
        <label class="field field--full">
          <span class="field-label">{{ 'OWNER_ADDRESS' | translate }}</span>
          <input class="form-control" formControlName="ownerAddress" />
        </label>
      </div>
    </section>

    <section class="form-section">
      <h2>Lease</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">{{ 'LEASE_STATUS' | translate }}</span>
          <select class="form-control" formControlName="leaseStatus">
            <option value="">—</option>
            <option *ngFor="let opt of dropdownOptions('leaseStatus')" [value]="opt">{{ opt | translate }}</option>
          </select>
        </label>
        <label class="field">
          <span class="field-label">{{ 'LEASING_COMPANY' | translate }}</span>
          <input class="form-control" formControlName="leasingCompany" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'LEASE_START_DATE' | translate }}</span>
          <input class="form-control" type="date" formControlName="leaseStartDate" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'LEASE_END_DATE' | translate }}</span>
          <input class="form-control" type="date" formControlName="leaseEndDate" />
        </label>
        <label class="field field--full">
          <span class="field-label">{{ 'LEASE_TERMS' | translate }}</span>
          <input class="form-control" formControlName="leaseTerms" />
        </label>
      </div>
    </section>

    <section class="form-section">
      <h2>Operations</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">{{ 'CURRENT_LOCATION' | translate }}</span>
          <input class="form-control" formControlName="currentLocation" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'DEPARTMENT' | translate }}</span>
          <input class="form-control" formControlName="department" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'OPERATIONAL_STATUS' | translate }}</span>
          <select class="form-control" formControlName="operationalStatus">
            <option value="">—</option>
            <option *ngFor="let opt of dropdownOptions('operationalStatus')" [value]="opt">{{ opt | translate }}</option>
          </select>
        </label>
        <label class="field">
          <span class="field-label">{{ 'CONDITION' | translate }}</span>
          <select class="form-control" formControlName="condition">
            <option value="">—</option>
            <option *ngFor="let opt of dropdownOptions('condition')" [value]="opt">{{ opt | translate }}</option>
          </select>
        </label>
        <label class="field">
          <span class="field-label">{{ 'USAGE_HOURS' | translate }}</span>
          <input class="form-control" type="number" formControlName="usageHours" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'FUEL_TYPE' | translate }}</span>
          <select class="form-control" formControlName="fuelType">
            <option value="">—</option>
            <option *ngFor="let opt of dropdownOptions('fuelType')" [value]="opt">{{ opt | translate }}</option>
          </select>
        </label>
        <label class="field">
          <span class="field-label">{{ 'FUEL_CONSUMPTION_RATE' | translate }}</span>
          <input class="form-control" type="number" formControlName="fuelConsumptionRate" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'OPERATOR_NAME' | translate }}</span>
          <input class="form-control" formControlName="operatorName" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'OPERATOR_LICENSE' | translate }}</span>
          <input class="form-control" formControlName="operatorLicense" />
        </label>
      </div>
    </section>

    <section class="form-section">
      <h2>Cost</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">{{ 'PURCHASE_DATE' | translate }}</span>
          <input class="form-control" type="date" formControlName="purchaseDate" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'ACQUISITION_COST' | translate }}</span>
          <input class="form-control" type="number" formControlName="acquisitionCost" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'CURRENT_VALUE' | translate }}</span>
          <input class="form-control" type="number" formControlName="currentValue" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'DEPRECIATION_RATE' | translate }}</span>
          <input class="form-control" type="number" formControlName="depreciationRate" />
        </label>
      </div>
    </section>

    <section class="form-section">
      <h2>Maintenance</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">{{ 'LAST_MAINTENANCE_DATE' | translate }}</span>
          <input class="form-control" type="date" formControlName="lastMaintenanceDate" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'NEXT_MAINTENANCE_DATE' | translate }}</span>
          <input class="form-control" type="date" formControlName="nextMaintenanceDate" />
        </label>
        <label class="field field--full">
          <span class="field-label">{{ 'MAINTENANCE_HISTORY' | translate }}</span>
          <input class="form-control" formControlName="maintenanceHistory" />
        </label>
      </div>
    </section>

    <section class="form-section">
      <h2>Warranty and insurance</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">{{ 'WARRANTY_STATUS' | translate }}</span>
          <select class="form-control" formControlName="warrantyStatus">
            <option value="">—</option>
            <option *ngFor="let opt of dropdownOptions('warrantyStatus')" [value]="opt">{{ opt | translate }}</option>
          </select>
        </label>
        <label class="field">
          <span class="field-label">{{ 'WARRANTY_EXPIRY_DATE' | translate }}</span>
          <input class="form-control" type="date" formControlName="warrantyExpiryDate" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'INSURANCE_STATUS' | translate }}</span>
          <select class="form-control" formControlName="insuranceStatus">
            <option value="">—</option>
            <option *ngFor="let opt of dropdownOptions('insuranceStatus')" [value]="opt">{{ opt | translate }}</option>
          </select>
        </label>
        <label class="field">
          <span class="field-label">{{ 'INSURANCE_PROVIDER' | translate }}</span>
          <input class="form-control" formControlName="insuranceProvider" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'INSURANCE_POLICY_NUMBER' | translate }}</span>
          <input class="form-control" formControlName="insurancePolicyNumber" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'LAST_UPDATED' | translate }}</span>
          <input class="form-control" formControlName="lastUpdated" readonly />
        </label>
        <label class="field field--full">
          <span class="field-label">{{ 'NOTES' | translate }}</span>
          <textarea class="form-control form-control--area" formControlName="notes" rows="2"></textarea>
        </label>
      </div>
    </section>

    <div class="mch-actions" *ngIf="!viewMode">
      <button type="button" class="ghost-btn" (click)="goBack()">{{ 'CANCEL' | translate }}</button>
      <button type="submit" class="primary-btn" [disabled]="machineForm.invalid || saving">
        {{ mId ? ('SAVE' | translate) : ('ADD' | translate) }}
      </button>
    </div>
  </form>
</div>
